import { Form, Radio } from 'antd';

/**
 * Telif Durumu seçimi (`copyrightStatus`): telif kullanıcıya ait (`claimed`) veya değil (`un_claimed`).
 * Yalnız Telif Türü `suggestion` iken gösterilir (bkz. MediaContentForm).
 *
 * @param {Object} props
 * @param {boolean} [props.disabled=false] - true ise radyolar salt-okunur olur (seçim değiştirilemez).
 *   Read-only detay modunda (SupervisorEditMediaContent → MediaContentForm) geçilir.
 */
function MediaCopyrightStatusRadioButton({ disabled = false }) {
  return (
    <Form.Item
      label="Telif Durumu"
      rules={[
        {
          required: true,
          message: 'Lütfen telif durumunu seçiniz',
        },
      ]}
      name="copyrightStatus"
    >
      <Radio.Group
        className="gx-w-100 gx-d-flex gx-align-items-center "
        disabled={disabled}
      >
        <Radio
          className="gx-w-50 gx-p-2"
          style={{
            border: '1px solid #f0f0f0',
          }}
          value="claimed"
        >
          Verdiğim medyanın telifi bana aittir ve kullanılmasına izin veriyorum
        </Radio>
        <Radio
          style={{
            border: '1px solid #f0f0f0',
            marginRight: 0,
          }}
          className="gx-w-50 gx-p-2"
          value="un_claimed"
        >
          Yüklediğim medyamın telifi bana ait değil
        </Radio>
      </Radio.Group>
    </Form.Item>
  );
}
export default MediaCopyrightStatusRadioButton;
